import {Link} from "gatsby";
import * as React from "react";

export default function NavItem ({children,to,name,className}){
    return (
        <li className={className} >
            <Link activeClassName={"active"} to={to}>
                {name || children}
            </Link>
        </li>
    )
};